import ReactDOM from 'react-dom/client'

import App from './App'

// Register service worker for production
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  let refreshing = false
  // Track if we already had a controller when page loaded
  const hadController = !!navigator.serviceWorker.controller

  // Reload page when new service worker takes control
  // But only if we already had a controller (this is an update, not initial registration)
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (refreshing || !hadController) return
    refreshing = true
    console.info('New service worker activated, reloading page')
    window.location.reload()
  })

  window.addEventListener('load', async () => {
    try {
      const registration = await navigator.serviceWorker.register('/sw.js', {
        scope: '/'
      })

      console.info('Kill switch service worker registered:', registration)

      // Force waiting service worker to activate immediately
      if (registration.waiting) {
        console.info('Service worker waiting, forcing activation')
        registration.waiting.postMessage({ type: 'SKIP_WAITING' })
      }

      // Check for updates periodically (every 60 seconds)
      setInterval(() => {
        registration.update()
      }, 60000)

      registration.addEventListener('updatefound', () => {
        const newWorker = registration.installing

        if (!newWorker) return

        newWorker.addEventListener('statechange', () => {
          if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
            console.info('New service worker installed, forcing activation')
            newWorker.postMessage({ type: 'SKIP_WAITING' })
          }
        })
      })
    } catch (error) {
      console.info('Service worker registration failed:', error)
    }
  })
}

async function enableMocking() {
  const mocksEnabled = import.meta.env.VITE_ENABLE_MOCKS === 'true'
  if (import.meta.env.PROD || !mocksEnabled) {
    return
  }

  const { setupMockWorker } = await import('./app/mock/worker.mock')
  await setupMockWorker().start({ onUnhandledRequest: 'bypass' })

  return Promise.resolve()
}

enableMocking().then(() => {
  ReactDOM.createRoot(document.getElementById('root')!).render(<App />)
})
